import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cd52a87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "badge-image-area" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "badge-name-area" }
const _hoisted_4 = { class: "badge-name" }
const _hoisted_5 = {
  key: 0,
  class: "badge-modal",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_6 = { class: "badge-modal__content" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "badge-modal__name" }
const _hoisted_9 = {
  key: 0,
  class: "badge-modal__desc"
}

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

type BadgeLike = {
  id?: number | string;
  name?: string;
  slug?: string;
  description?: string | null;
  photo_path?: string | null;
  photoUrl?: string | null;
  image?: string | null;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    badge: null
  },
  setup(__props: any) {

const props = __props as {
  badge: BadgeLike;
}



const srcIndex = ref(0);
const isOpen = ref(false);

const slugify = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const normalizeBadgePath = (value?: string | null) => {
  if (!value) return null;
  if (value.startsWith("/media/badges/")) {
    return value.replace("/media/badges/", "/media/logos/badges/");
  }
  return value;
};

const imgSources = computed(() => {
  const nameSlug = props.badge?.name ? slugify(props.badge.name) : "";
  const normalizedPhotoPath = normalizeBadgePath(props.badge?.photo_path);
  const normalizedPhotoUrl = normalizeBadgePath(props.badge?.photoUrl);
  const normalizedImage = normalizeBadgePath(props.badge?.image);

  const candidates = [
    normalizedPhotoPath,
    normalizedPhotoUrl,
    normalizedImage,
    props.badge?.slug ? `/media/logos/badges/${props.badge.slug}.png` : null,
    nameSlug ? `/media/logos/badges/${nameSlug}.png` : null,
    "/media/icons/duotune/general/gen026.svg",
  ].filter(Boolean) as string[];

  // Deduplicate: same URL appearing twice blocks Vue from updating src,
  // preventing the @error chain from advancing to the fallback.
  return candidates.filter((url, i) => candidates.indexOf(url) === i);
});

const imgSrc = computed(() => {
  const idx = Math.min(srcIndex.value, imgSources.value.length - 1);
  return imgSources.value[idx];
});

const onImgError = () => {
  if (srcIndex.value < imgSources.value.length - 1) {
    srcIndex.value += 1;
  }
};

const badgeName = computed(() => props.badge?.name || "Badge");
const badgeDescription = computed(() => props.badge?.description || "");

const open = () => {
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
};

const onKeydown = (e: KeyboardEvent) => {
  if (e.key === "Escape") close();
};

watch(
  () => props.badge,
  () => {
    srcIndex.value = 0;
  },
  { deep: true }
);

watch(isOpen, (openNow) => {
  document.body.style.overflow = openNow ? "hidden" : "";
});

onMounted(() => {
  window.addEventListener("keydown", onKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", onKeydown);
  document.body.style.overflow = "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "badge-card",
      onClick: open
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "badge-image",
          src: _unref(imgSrc),
          alt: _unref(badgeName),
          onError: onImgError,
          loading: "eager"
        }, null, 40, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(badgeName)), 1)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "badge-modal__backdrop",
              onClick: close
            }),
            _createElementVNode("div", {
              class: "badge-modal__panel",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "badge-modal__close",
                onClick: close,
                "aria-label": "Close"
              }, " × "),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "badge-modal__image",
                  src: _unref(imgSrc),
                  alt: _unref(badgeName),
                  onError: onImgError
                }, null, 40, _hoisted_7),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(badgeName)), 1),
                (_unref(badgeDescription))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(badgeDescription)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})